import React, { useEffect, useState, useRef } from "react";
import Classes from "./styles/style.module.css";
import QRCode from "react-fancy-qrcode";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import { useParams } from "react-router";
import appApi from "../../../assets/utils/AppApi";
import errorHandler from "../../../assets/utils/ErrorHandler";
import Loading from "../../../assets/containers/loadingDialog";
import CustomHint from "../../../assets/containers/CustomHint";
import FooladLogo from "../../../assets/images/icons/fooladLogo.svg";

const Ticket = () => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [ticketData, setTicketData] = useState(null);

  const qrContainerRef = useRef(null);
  const [qrSize, setQrSize] = useState(0);

  const updateQrSize = () => {
    if (qrContainerRef.current) {
      setQrSize(qrContainerRef.current.clientWidth - 36);
    }
  };

  // const exportPDF = () => {
  //   const input = document.getElementById("divToExport");

  //   html2canvas(input, {
  //     scale: 1,
  //     useCORS: true,
  //     scrollX: -window.scrollX,
  //     scrollY: -window.scrollY,
  //   }).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF({
  //       orientation: "p",
  //       unit: "px",
  //       format: [canvas.width, canvas.height],
  //     });

  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = pdf.internal.pageSize.getHeight();

  //     const imgProps = pdf.getImageProperties(imgData);
  //     const imgWidth = pdfWidth;
  //     const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

  //     const position = 0;
  //     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);

  //     pdf.save("download.pdf");
  //   });
  // };

  useEffect(() => {
    updateQrSize();
    window.addEventListener("resize", updateQrSize);
    return () => window.removeEventListener("resize", updateQrSize);
  }, []);

  useEffect(() => {
    getTicketInfor();
  }, []);

  const getTicketInfor = async () => {
    setLoading(true);
    try {
      await appApi
        .get(`/eventTicket/getsingle/${params.ticketId}`)
        .then(({ data }) => {
          setTicketData(data.ticket);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  console.log(qrSize)

  return (
    <AnimatedPageContainer>
      <div className={"customContainer"} id="divToExport">
        <div className="w-100 my-3">
          <CustomHint
            hint={
              "از صفحه‌ی خود تصویری تهیه نموده وهنگام مراجعه به متصدی ارائه نمایید."
            }
          />
        </div>
        {loading ? (
          <div className="w-100 d-flex justify-content-center py-5 my-5">
            <Loading size={30} />
          </div>
        ) : (
          <div className={Classes.qrContainer} ref={qrContainerRef}>
            {ticketData && (
              <QRCode
                logo={FooladLogo}
                removeQrCodeBehindLogo
                value={JSON.stringify({
                  _id: params?.ticketId,
                  type: "Event",
                })}
                dotScale={0.8}
                dotRadius="50%"
                positionRadius={["5%", "1%"]}
                size={qrSize}
                errorCorrection="H"
              />
            )}
            <p className="text-center mt-3 mb-0">{ticketData?.event?.name}</p>
          </div>
        )}
        <div className={Classes.tecketDetailsContainer}>
          {loading ? (
            <div className="w-100 d-flex justify-content-center py-5 my-5">
              <Loading size={30} />
            </div>
          ) : (
            ticketData && (
              <>
                <div>
                  <p>عنوان رخداد :</p>
                  <p>{ticketData.event.name}</p>
                </div>
                <div>
                  <p>نام و نام‌خانوادگی :</p>
                  <p>{ticketData.owner.fullName}</p>
                </div>
                <div>
                  <p>تعداد نفرات :</p>
                  <p>{ticketData.participants}</p>
                </div>
                <div>
                  <p>سانس :</p>
                  <p>{ticketData.section.name}</p>
                </div>
              </>
            )
          )}
        </div>
      </div>
      {/* <div>
        <CustomButton
          color={"primary"}
          text={"دانلود بلیط"}
          shadow={true}
          styles={{
            width: "85%",
            marginInline: "auto",
            display: "block",
            marginBlock: "30px",
          }}
          clickHandler={exportPDF}
        />
      </div> */}
    </AnimatedPageContainer>
  );
};

export default Ticket;
